import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const CheckoutSuccessPage: React.FC = () => {
    useEffect(()=>{
        Office.context.ui.messageParent(
            JSON.stringify(
            {
                message:"success"
            }
        ));
    })

    return(
        <div></div>
    );

}

export default CheckoutSuccessPage;
